import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { IPartnerInfo } from '@mng/mgs-lib';
import { inject } from '@angular/core';
import { PartnerDetailService } from './partner-detail.service';
import { BuchungPartnerService } from '../buchung-partner.service';
import { AuthStateFacade } from '../../auth/auth-state.facade';

export const partnerDetailResolver: ResolveFn<IPartnerInfo> = async (route: ActivatedRouteSnapshot) => {
  const partnerDetailService = inject(PartnerDetailService);
  const buchungPartnerService = inject(BuchungPartnerService);
  const authState = inject(AuthStateFacade);

  if (!authState.isAdmin()) {
    return undefined;
  }

  await buchungPartnerService.resolveBuchungPartnerDaten();

  let partnerId = +route.paramMap.get('id');

  if (!partnerId) {
    partnerId = +route.queryParams['partnerId'];
  }

  if (partnerId) {
    return partnerDetailService.resolvePartner(partnerId);
  } else {
    partnerDetailService.neuerPartner();
    return undefined;
  }
};
